/* eslint-disable no-unreachable */
<style>
  .keyword .vs-con-input input {
    /* height: 39px !important; */
  }
</style>
<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">

          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|max:255'"
                data-vv-validate-on="blur"
                type="text"
                name="topicName"
                label="Tên chủ đề"
                v-model="topic.topicName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("topicName")
              }}</span>
            </div>
          </div>

         <div class="vx-row">
           <div class="vx-col md:w-1/3 w-full mt-2" v-if="isCreateGroup == 0">
             <label class="vs-input&#45;&#45;label">Nhóm chủ đề</label>
             <v-select
               class=""
               v-model="getTopicGroups"
               :clearable="false"
               :options="topicGroupOptions"
               data-vv-validate-on="input"
               name="topicGroupName"/>
           </div>
           <div class="vx-col md:w-1/3 w-full mt-2" v-if="isCreateGroup == 0">
             <vs-button @click="createTopicGroup" style="margin-top: 19px">Tạo nhóm chủ đề</vs-button>
           </div>

           <div class="vx-col md:w-1/3 w-full mt-2" v-if="isCreateGroup == 1">
             <vs-input
               v-validate="'required'"
               data-vv-validate-on="blur"
               type="text"
               name="topicGroupName"
               label="Tên nhóm chủ đề"
               v-model="topicGroupName"
               autocomplete="off"
               class="w-full"/>
             <span class="text-danger text-sm">{{
               errors.first("topicGroupName")
             }}</span>
           </div>

           <div class="vx-col md:w-1/3 w-full mt-2" v-if="isCreateGroup == 1">
             <vs-button @click="saveTopicGroup" :disabled="!validateForm" style="margin-top: 19px">Tạo mới</vs-button>
             <vs-button @click="cancelCreate" style="margin-left: 15px; margin-top: 19px">Bỏ qua</vs-button>
           </div>
         </div>
          <div class = "row mt-6">
            <label class="vs-input--label" >Từ khóa loại trừ</label>
            </div>
           <div class="vx-row" >

            <div class="vx-col md:w-1/3 w-full"  v-for="(item) in tagsListAction" >
              <div class="vx-col col-12 w-full">
                <vue-tags-input style = "margin-top: 0px !important;"
                v-validate="'max:255'"
                placeholder="Tin bài chứa các từ khóa spam, rác sẽ không được thu thập."
                v-model="item.tag2"
                :tags=item.action
                @tags-changed="newTags => item.action = newTags"
                allow-edit-tags
                />
              </div>
            </div>
          </div>
          <div class="vx-row mt-6">

            <div class="vx-col md:w-1/3 w-full mt-2"><label class="vs-input--label" >Từ khóa chính</label></div>
            <div class="vx-col md:w-1/3 w-full mt-2"><label class="vs-input--label" >Từ khóa phụ</label></div>
          </div>
          <div class="vx-row mt-3 keyword"  v-for="(item,index) in keywords" >
            <div class="vx-col md:w-1/3 w-full">
              <vs-input
                style = "height: 39px;"
                v-validate="'required|max:4000'"
                data-vv-validate-on="blur"
                type="text"
                placeholder="Tên thương hiệu, Sản phẩm, Chiến dịch, Các vấn đề cần theo dõi...."
                name="keyword"
                v-model="item.keyword"
                autocomplete="off"
                class="w-full"/>
              <!-- <span class="text-danger text-sm">{{
                errors.first("keyword")
              }}</span> -->
            </div>
            <div class="vx-col md:w-1/3 w-full">
              <vue-tags-input style = "margin-top: 0px !important;"
                placeholder = "Mô tả cụ thể kèm theo từ khóa chính"
                v-model="item.tag"
                :tags=item.action
                @tags-changed="newTags => item.action = newTags"
                @before-adding-tag="checkTag"
                allow-edit-tags
                v-validate="'max:50'"
                name="keywordDependent"
              />

              <span class="text-danger text-sm">{{
                errors.first("keywordDependent")
              }}</span>
            </div>


              <div class="vx-col" style="line-height: 39px;">
                <feather-icon icon="PlusIcon" style = "vertical-align: middle" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" title="Thêm từ khóa" @click="addNewRecord(index + 1)"/>
                <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" title="Xóa từ khóa" @click="confirmDeleteRecord(index)"/>
              </div>
            </div>
          </div>

            <div class="article">
              <span class="source">Nguồn tin</span>
              <div class="vx-row" style="margin: 20px 0px 0px 5px">
                  <div class="vx-col md:w-1/3 w-full mt-2 nt">
                      <vs-checkbox v-model="checkBox">Báo chí</vs-checkbox>
                  </div>

                  <div class="vx-col md:w-1/3 w-full mt-2 nt">
                      <vs-checkbox style="width:100%" v-model="checkBox1">Mạng xã hội</vs-checkbox>
                  </div>

                  <div class="vx-col md:w-1/4 w-full mt-2 nt">
                      <vs-checkbox v-model="checkBox2">Nguồn khác</vs-checkbox>
                  </div>

            </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
                  'Cập nhật': 'Tạo mới'}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">Quay lại
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>
<style>
  .vue-tags-input{
    margin-top: 20px;
  }
  .ti-input{
    border-radius: 5px;
    padding: 6px;
  }
</style>
<script>

  import vSelect from 'vue-select'
  import Datepicker from '@/components/datepicker/Datepicker.vue';
  import VueTagsInput from '@johmun/vue-tags-input';
  export default {
    data() {
      return {
        tag2:'',
        tag3:'',
        tag: '',
        keywords: [{
          keyword:"",
          action: []
        }],
        isCreateGroup: 0,
        topicGroupName: null,
        isUpdate: false,
        id: null,
        topicGroupOptions: [],
        registerSuccess: 0,
        topic: {
          topicName: null,
          topicGroupId: null,
          excludeKeyword:null,
          articleSource:[]
        },
        tagsListAction:[{
          action:[]
        }],
        tagsListArticle:[{
          action:[]
        }],
        checkBox:true,
        checkBox1:true,
        checkBox2:true,
        valueCheckbox:[]
      };
    },
    components: {
      VueTagsInput,
      vSelect,
      Datepicker
    },
    computed: {
      validateForm() {
        return !this.errors.any();
      },
      getTopicGroups: {
        get() {
          let obj = this.topicGroupOptions.find(x => x.value === this.topic.topicGroupId);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.topic.topicGroupId
          }
        },
        set(obj) {
          this.topic.topicGroupId = obj.value;
        }
      },
      getValueArticle:{
        get(){
          let object = this.articleSourceOptions.find(el => el.value);
          if(!object){
            return null;
          }
          return {
            value: this.topic.articleSource,
            label:object.label
          }
        },
        set(object){
          this.topic.articleSource = object.map(el => el.value);
        }
      }
    },
    async created() {
      await this.getGroupTopic(this);
      this.topic.id = this.$route.query.id;
      if (this.topic.id) {
        this.$vs.loading();
        this.$business.get('/topic/find-by-id/' + this.topic.id).then((response) => {
          this.topic.topicName = response.data.topicName;
          this.topic.topicGroupId = response.data.topicGroupId;
          let keywordsRes = response.data.keywords;
          let excludeKeyword = response.data.excludeKeyword;
          let articleSource = response.data.articleSource;
          this.isUpdate=true;
          keywordsRes.forEach(keyword => {
            keyword.action = keyword.action.map(action => {
              return {
                text: action,
                tiClasses: ["ti-valid"]
              }
            })
          });
          if (Array.isArray(articleSource)) {
            this.checkBox = false;
            this.checkBox2 = false;
            this.checkBox3 = false;
            if  (articleSource.includes(101) || articleSource.includes(102)) this.checkBox = true;
            if  (articleSource.includes(103) || articleSource.includes(104) || articleSource.includes(105) || articleSource.includes(106)) this.checkBox2 = true;
            if  (articleSource.includes(110) || articleSource.includes(113)) this.checkBox3= true;
          }
          this.topic.articleSource = articleSource;
          this.tagsListAction = [{"action": excludeKeyword.map (item => {
            return {
                  text:item,
                  tiClasses:['ti-valid']
                }
          })}] ;
          this.keywords = keywordsRes;
          this.isUpdate = true;
          this.$vs.loading.close();
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    methods: {
      checkIfDuplicateExists(w){
        return new Set(w).size !== w.length
      },
      checkTag(obj) {
        obj.addTag();
      },
      addNewRecord(index) {
        this.keywords.splice(index, 0, {})
      },
      confirmDeleteRecord(index) {
        if(this.keywords.length == 1) {
          return this.$vs.notify({
            text: "Chủ đề phải có ít nhất 1 từ khóa.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        this.keywordId = index;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Xác nhận xoá`,
          text: `Bạn có chắc là muốn xoá`,
          accept: this.deleteRecord,
          acceptText: "Xoá",
          cancelText: "Huỷ"
        })
      },
      deleteRecord() {
        this.keywords.splice(this.keywordId, 1)
      },

      createTopicGroup() {
        this.isCreateGroup = 1;
      },
      saveTopicGroup() {
        this.$vs.loading();
        let conditions = {
          "groupName": this.topicGroupName
        }
        this.$business.post("/topic-group/create", conditions).then(async () => {
          await this.getGroupTopic(this);
          this.isCreateGroup = 0;
          this.$vs.loading.close();
        }).catch(err => {
          this.isCreateGroup = 0;
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
      cancelCreate(){
        this.isCreateGroup = 0;
      },
      async getGroupTopic(that) {
        try {
          that.topicGroupOptions = await new Promise(function (resolve, reject) {
            that.$business.post('topic-group/find-by-conditions').then((topicGroup) => {
              resolve(topicGroup.data);
            }).catch((err) => {
              reject(err);
            });
          });
        } catch (err) {
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        if (that.topicGroupOptions.length > 0) {
          that.topicGroupOptions = that.topicGroupOptions.map(topicGroup => {
            return {
              value: topicGroup.id,
              label: topicGroup.groupName
            }
          });
        }
      },
      getLabelString(object) {
        return (object && object.label);
      },
      async saveChanges(evt) {

        evt.preventDefault();
        const keyword = this.keywords.map(key =>{
          return key.keyword;
        })
        for(let i = 0;i<keyword.length;i++){
          if(!keyword[i]){
            return this.$vs.notify({
            text: " Từ khóa chính không được để trống",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          }
        }
        let validate = await this.$validator.validateAll();
        if (!this.validateForm) return;
        if(!validate) return;
        let isCheckDuplicateKeyword = this.checkIfDuplicateExists(this.keywords.map(x => x.keyword));
        if(isCheckDuplicateKeyword) {
          return this.$vs.notify({
            text: " Từ khóa chính phải là duy nhất.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }

        const result = await this.$validator.validateAll();
        if (!result) return;
        if(this.keywords){
          this.keywords = this.keywords.map(keyword => {
          let action = [];
          if(keyword.action) {
            action = keyword.action.map(action => {return action.text;}).filter(item => item);
          }
          return {
            keyword: keyword.keyword,
            action: action
          }
        });
        }
        this.valueCheckbox = []
        if(this.checkBox)  this.valueCheckbox.push(101, 102);
        if(this.checkBox1) this.valueCheckbox.push(...[103, 104, 105, 106]);
        if(this.checkBox2) this.valueCheckbox.push(...[108, 109, 110, 113]);

        let checked = false;
        let dataTagList = this.tagsListAction.map(el => {
          el.tags  = el.action.map(t => t.text);
          let key = this.keywords.map(keyword =>{
            return keyword.keyword;
          })
          let tags = el.tags;
          for(let i=0; i< tags.length; i++){
            if(key[0] == tags[i]){
              key[0] += tags[i]
              checked = true;
            }
          }

        });
        if(checked){
            return this.$vs.notify({
              text: " Từ khóa chính không được trùng với từ khóa loại trừ.",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
        }
        if (this.valueCheckbox.length == 0 ){
          return this.$vs.notify({
            text: "Phải chọn ít nhất một nguồn tin",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        this.topic.articleSource = this.valueCheckbox;
        this.topic.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
        this.topic.keywords = this.keywords;
        let path = this.isUpdate ? ('/topic/update') : '/topic/create';
        this.$vs.loading();
        this.$business.post(path, this.topic).then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: 'primary',
            text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} chủ đề thành công`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.$router.push('/user/topic/manage').catch(() => {
          })
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
    }
  };
</script>

<style lang="stylus">
.article{
  front-size: 10px
  border-radius: 5px
  margin: 10px 0px 10px 0px
}
.nt {
    width: 10% !important;
    min-width : 150px;
    max-width : 200px;
}
.source{
  font-size:12.5px;
  margin:0px 0px 0px 5px
}
</style>
